import dayjs from 'dayjs';
import calendar from 'dayjs/plugin/calendar';
import * as relativeTime from 'dayjs/plugin/relativeTime';
dayjs.extend(calendar);
dayjs.extend(relativeTime);

const DateHumanizeHelper = (date) => {
    return dayjs(date).calendar(null, {
        sameDay: function () {
            return `${dayjs(date).fromNow()}`;
        },
        nextDay: '[Tomorrow]',
        nextWeek: '[Next] dddd',
        lastDay: '[Yesterday]',
        lastWeek: 'dddd',
        sameElse: 'D MMM YYYY',
    });
};

export default DateHumanizeHelper;
